import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SB_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SB_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SB_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SB_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 24h32V0L0 24z",
      fill: "#579D20"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-.782 24.745l-1.804-2.496L33.675-1.954 35.479.542-.782 24.746z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.653 6.547L5.017 5.6l1.428.85-.5-1.524.998-1.09H5.59l-.573-1.603-.574 1.602-1.355.056 1 1.035-.435 1.62zm5.658 0l1.364-.946 1.428.85-.5-1.524.998-1.09h-1.353l-.573-1.603-.574 1.602-1.355.056 1.001 1.035-.436 1.62z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.647 9.455l1.364-.946 1.428.85-.5-1.524.998-1.09H8.584l-.573-1.602-.574 1.601-1.355.056 1.001 1.035-.436 1.62zm-1.63 2.146l-1.364.946.436-1.62-1.001-1.035 1.355-.056.574-1.601.573 1.601h1.353l-.998 1.091.5 1.525-1.428-.85zm5.658 0l-1.364.946.436-1.62-1-1.035 1.354-.056.574-1.601.573 1.601h1.354l-1 1.091.501 1.525-1.428-.85z",
      fill: "#F7FCFF"
    }
  )))
), a = t;
export {
  a as default
};
